<template>
  <div class="userlist">
    <userlist-container></userlist-container>
  </div>
</template>
<script>
import UserlistContainer from '@/components/userlist/Container.vue'
export default {
  name: 'userlist',
  components: {
    UserlistContainer
  }
}
</script>
<style lang="stylus">
.userlist
  height 100%
</style>
